module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "contact"
  }, [_c('h3', [_vm._v("Contact")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Questions, issues or suggestions?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('dt', [_vm._v("Email")]), _vm._v(" "), _c('dd', [_vm._v("cixx@cyberdyne.sh")]), _vm._v(" "), _c('dt', [_vm._v("IRC")]), _vm._v(" "), _c('dd', [_vm._v("#forklol on freenode")]), _vm._v(" "), _c('dt', [_vm._v("Slack")]), _vm._v(" "), _c('dd', [_vm._v("trippysalmon on bitcoincore.slack.com")]), _vm._v(" "), _c('dt', [_vm._v("Twitter")]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "https://twitter.com/trippysalmon"
    }
  }, [_vm._v("@trippysalmon")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("Donations")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "row justify-content-around text-center"
  }, [_c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('p', [_vm._v("Donate Bitcoin:")]), _vm._v(" "), _c('p', [_vm._v("1F43wkTWaUVyDbtfJrHXpc3C1ek5kcK8A")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "bitcoin:1F43wkTWaUVyDbtfJrHXpc3C1ek5kcK8A"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/qr_btc.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("(image is clickable)")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "hidden-md-up"
  }, [_c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', [_vm._v("Donate Bitcoin Cash:")]), _vm._v(" "), _c('p', [_vm._v("1BFeA4phuDxfh4nqnRk9tjzYt9viQEvQkq")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/qr_bch.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-690046db","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact.vue
// module id = 549
// module chunks = 1